import React from 'react'
import { Link } from 'react-router-dom'
import "../Css/Custom.css"
import Logo from '../Images/LOGO 1.png'

function Navbar() {
    const liStyle = {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: "600",
        color: "black!important"
    };
    return (
        <>
            <nav class="navbar navbar-expand-lg navbar-light bg-light  sticky-top" style={{ borderBottom: "1px solid #89c764" }}>
                <div class="container">
                    <Link to="/">
                        <img src={Logo} alt="logo" style={{ width: "95px", cursor: "pointer" }} title="COMPLIANCEKARE" />
                    </Link>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav ms-auto">
                            <li class="nav-item" style={liStyle}>
                                <Link to="/" class="nav-link">HOME</Link>
                            </li>

                            <li class="nav-item dropdown" style={liStyle}>
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    NEW BUSINESS
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><Link to="/Propitorship" class="dropdown-item" >Proprietorship</Link></li>
                                    <li><Link to="/partnership" class="dropdown-item" >Partnership Firm</Link></li>
                                    <li><a class="dropdown-item" href="#">LLP registration</a></li>
                                    <li><a class="dropdown-item" href="#">Private Limited Company</a></li>
                                    <li><a class="dropdown-item" href="#">one Person Company</a></li>
                                    <li><a class="dropdown-item" href="#">Limited Company</a></li>
                                    <li><a class="dropdown-item" href="#">Nidhi Company</a></li>
                                    <li><a class="dropdown-item" href="#">NBFC Registration</a></li>
                                    <li><a class="dropdown-item" href="#">Core Investment company</a></li>
                                    <li><a class="dropdown-item" href="#">Producer company</a></li>
                                    <li><a class="dropdown-item" href="#">Section 8 company</a></li>
                                    <li><a class="dropdown-item" href="#">Trust</a></li>
                                    <li><a class="dropdown-item" href="#">Society</a></li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown" style={liStyle}>
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    INCOME TAX
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a class="dropdown-item" href="#">Pan Application</a></li>
                                    <li><a class="dropdown-item" href="#">Link Adhar with PAN</a></li>
                                    <li><a class="dropdown-item" href="#">TAN Application</a></li>
                                    <li><a class="dropdown-item" href="#">Income Tax Return</a></li>
                                    <li><a class="dropdown-item" href="#">TDS Return</a></li>
                                    <li><a class="dropdown-item" href="#">TDS on property</a></li>
                                    <li><a class="dropdown-item" href="#">TCS Return</a></li>
                                    <li><a class="dropdown-item" href="#">Income Tax Refund</a></li>
                                    <li><a class="dropdown-item" href="#">Income Tax Notice</a></li>
                                    <li><a class="dropdown-item" href="#">Registration 12AA/80G</a></li>
                                    <li><a class="dropdown-item" href="#">Income Tax Demand</a></li>
                                    <li><a class="dropdown-item" href="#">Advance Tax Calculation</a></li>
                                    <li><a class="dropdown-item" href="#">Income Tax Planning</a></li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown" style={liStyle}>
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    GST
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a class="dropdown-item" href="#">GST Registration</a></li>
                                    <li><a class="dropdown-item" href="#">GST Return</a></li>
                                    <li><a class="dropdown-item" href="#">GST Refund</a></li>
                                    <li><a class="dropdown-item" href="#">GST Notice</a></li>
                                    <li><a class="dropdown-item" href="#">GST Demand</a></li>
                                    <li><a class="dropdown-item" href="#">GST Registration Surrender</a></li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown" style={liStyle}>
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    COMPLIANCE
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a class="dropdown-item" href="#">MSME Registration</a></li>
                                    <li><a class="dropdown-item" href="#">FSSAI Registration</a></li>
                                    <li><a class="dropdown-item" href="#">Trademark Registration</a></li>
                                    <li><a class="dropdown-item" href="#">ISO certification</a></li>
                                    <li><a class="dropdown-item" href="#">Company law compliance</a></li>
                                    <li><a class="dropdown-item" href="#">LLP law compliance</a></li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown" style={liStyle}>
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    LOANS
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a class="dropdown-item" href="#">PROJECT REPOERT</a></li>
                                    <li><a class="dropdown-item" href="#">BUSINESS PLANNING</a></li>
                                    <li><a class="dropdown-item" href="#">BUSINESS LOAN</a></li>
                                    <li><a class="dropdown-item" href="#">CC OR OVERDRAFT</a></li>
                                    <li><a class="dropdown-item" href="#">PERSONAL LOAN</a></li>
                                    <li><a class="dropdown-item" href="#">INTER CORPORATE LOANS</a></li>
                                    <li><a class="dropdown-item" href="#">HOME LOANS</a></li>
                                    <li><a class="dropdown-item" href="#">EDUCATION LOAN</a></li>
                                    <li><a class="dropdown-item" href="#">LOAN AGAINST PROPERTY</a></li>
                                    <li><a class="dropdown-item" href="#">VEHICLE LOAN</a></li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown" style={liStyle}>
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    INVESTMENT
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a class="dropdown-item" href="#">Mutual fund</a></li>
                                    <li><a class="dropdown-item" href="#">Demat Account</a></li>
                                    <li><a class="dropdown-item" href="#">Investment in real estate</a></li>
                                    <li><a class="dropdown-item" href="#">Fixed Deposits</a></li>
                                    <li><a class="dropdown-item" href="#">Bonds</a></li>
                                    <li><a class="dropdown-item" href="#">Life Insurance</a></li>
                                    <li><a class="dropdown-item" href="#">Term Insurance</a></li>
                                    <li><a class="dropdown-item" href="#">General insurance</a></li>
                                    <li><a class="dropdown-item" href="#">Health Insurance</a></li>
                                    <li><a class="dropdown-item" href="#">Annuity Plan</a></li>
                                    <li><a class="dropdown-item" href="#">Retirement plans</a></li>

                                </ul>
                            </li>

                            <li class="nav-item" style={liStyle}>
                                <Link to="/contact" class="nav-link" >CONTACT US</Link>
                            </li>
                            <Link to="/login">
                                <button type="button" class="btn btn-outline-success" style={{border:"1px solid green",color:"green"}}>
                                    LOGIN
                                </button>
                            </Link>


                        </ul>
                    </div>
                </div>
            </nav>

        </>
    )
}

export default Navbar